import { AxiosResponse } from 'axios';
import {
  B2B_ACCOUNT_CONTACT_NUMBER_PATH,
  B2B_ACCOUNT_PROFILE_PATH,
} from '../../constants/links';
import { apiB2B } from '../axios-client';
import { TAccountProfileResponse } from '../../models/b2b/account';
import { withUserContext, withUserId } from '../utils';

export const b2bAccountApi = {
  profileDetails: withUserContext(
    (userId, svocId): Promise<AxiosResponse<TAccountProfileResponse>> => {
      return apiB2B.get(B2B_ACCOUNT_PROFILE_PATH(userId, svocId));
    },
  ),
  getContactNumber: withUserId((userId: string) => {
    return apiB2B
      .get<{
        contactCenterNumber: string;
        smsShortCode: string;
      }>(B2B_ACCOUNT_CONTACT_NUMBER_PATH(userId))
      .then(({ data }) => data);
  }),
};
